import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { ConsultaDocumentacionInmueblesComponent } from './ConsultaDocumentacionInmuebles.component';
import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';
import { MatDialogModule } from '@angular/material';



const routes = [
    {
        path     : 'ConsultaDocumentacionInmuebles',
        component: ConsultaDocumentacionInmueblesComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ConsultaDocumentacionInmuebles',
          nombreFormulario : 'ConsultaDocumentacionInmuebles'
        } 
    },
    {
        path     : 'Escritura/i/:cnumcont/:cprefijo/:edi',
        component: ConsultaDocumentacionInmueblesComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ConsultaDocumentacionInmuebles',
          nombreFormulario : 'ConsultaDocumentacionInmuebles'
        } 
    },
    {
        path     : 'Escritura/:cnumcont/:ccodcon',
        component: ConsultaDocumentacionInmueblesComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ConsultaDocumentacionInmuebles',
          nombreFormulario : 'Escritura Filtro Contrato - Prefijo'
        } 
    }

];

@NgModule({
    declarations: [
        ConsultaDocumentacionInmueblesComponent,
        
    ],
    imports     : [
        SharedModule,
        MatDialogModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ConsultaDocumentacionInmueblesComponent,
    ]
})

export class ConsultaDocumentacionInmueblesModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ConsultaDocumentacionInmuebles/ConsultaDocumentacionInmuebles.module.ts